import { z } from "zod";

import { VOICE_GROUP_IDS } from "@/shared/group-configs/groups";
import { phoneNumberSchema } from "@/shared/utils/phone-utils";

export const getWaitTimeRequestSchema = z.object({
  groupId: z.enum(VOICE_GROUP_IDS),
  calledNumber: phoneNumberSchema,
});

export const getWaitTimeResponseSchema = z.object({
  estimatedWaitTimeRange: z.string().trim().min(1).max(100),
});

export type GetWaitTimeRequest = z.infer<typeof getWaitTimeRequestSchema>;
export type GetWaitTimeResponse = z.infer<typeof getWaitTimeResponseSchema>;
